{
  "verse": {
    "loading": "Memuatkan ayat...",
    "error": "Tidak dapat memuatkan ayat",
    "reference": "— Surah {{surah}}, Ayat {{ayah}}",
    "arabicUnavailable": "(Bahasa Arab tidak tersedia)",
    "english": "Inggeris",
    "arabic": "العربية",
    "swapLanguage_aria": "Tukar bahasa",
    "toggleLanguage_title": "Tukar Inggeris / Arab",
    "reflect": "Renung",
    "reflecting": "Sedang berfikir…",
    "reflect_aria": "Jana renungan peribadi yang menghubungkan ayat ini dengan niat anda",
    "insights": "Wawasan",
    "insights_aria": "Buka Wawasan Quran AI",
    "share": "Kongsi",
    "share_aria": "Kongsi ayat ini sebagai imej",
    "share_title": "Kongsi ayat ini",
    "removeFromFavorites_aria": "Buang daripada kegemaran",
    "saveToFavorites_aria": "Simpan ke kegemaran",
    "favoritesProLocked_aria": "Kegemaran ialah ciri Pro",
    "favoritesUpgrade_aria": "Naik taraf untuk menyimpan kegemaran",
    "signInToSave": "Log masuk untuk menyimpan kegemaran.",
    "failedToUpdateFavorites": "Gagal mengemas kini kegemaran",
    "couldNotReflect": "Tidak dapat menjana renungan",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayat {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Imej disimpan · ayat disalin",
    "imageSaved": "Imej ayat disimpan",
    "couldNotCreateImage": "Tidak dapat mencipta imej"
  },
  "insights": {
    "panel_aria": "Panel Wawasan Quran",
    "title": "Wawasan",
    "reference": "Surah {{surah}}, Ayat {{ayah}}",
    "close_aria": "Tutup panel Wawasan",
    "versePreview_aria": "Pratonton ayat",
    "back_aria": "Kembali",
    "tryAgain": "Cuba lagi",
    "backTo_aria": "Kembali ke {{ref}}",
    "copyVerse_aria": "Salin {{ref}}",
    "openingVerse": "Sedang membuka ayat…",
    "verseError": "Ayat tidak dapat dibuka."
  },
  "proGate": {
    "title": "Wawasan Quran AI ialah ciri Pro",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "Buka pemahaman yang mendalam dan kontekstual bagi setiap ayat.",
    "bulletAsk": "Tanya sebarang soalan tentang ayat",
    "bulletTafsir": "Ringkasan tafsir kuasa AI serta-merta",
    "bulletRelated": "Temui ayat yang berkaitan secara tema",
    "upgrade": "Naik taraf ke Pro"
  },
  "ask": {
    "heading": "Tanya",
    "suggestion1": "Apakah konteks yang lebih luas bagi ayat ini?",
    "suggestion2": "Bagaimana saya boleh mengamalkannya dalam kehidupan harian?",
    "suggestion3": "Apa kata ulama klasik tentang hal ini?",
    "placeholder": "Tanya apa-apa tentang ayat ini…",
    "input_aria": "Tanya soalan tentang ayat ini",
    "submit_aria": "Hantar soalan",
    "submit_title": "Hantar (⌘↵)",
    "submit_label": "Tanya",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Soalan yang dicadangkan",
    "error": "Tidak dapat memperoleh jawapan.",
    "pending": "Merenung pertanyaan anda…",
    "attribution": "Jawapan jana AI · Bukan pengganti kepada keilmuan yang berkelayakan"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Dapatkan ringkasan tafsir jana AI untuk ayat ini.",
    "generate": "Jana Tafsir",
    "commentary": "Ulasan",
    "regenerate": "Jana semula",
    "regenerate_aria": "Jana semula tafsir",
    "attribution": "Ringkasan jana AI · Bukan pengganti kepada keilmuan yang berkelayakan",
    "error": "Tidak dapat menjana tafsir.",
    "pending": "Membaca ulasan…"
  },
  "related": {
    "heading": "Ayat Berkaitan",
    "copied": "Disalin: {{ref}}",
    "failedToCopy": "Gagal menyalin",
    "empty": "Tiada ayat berkaitan ditemui.",
    "error": "Tidak dapat memuatkan ayat berkaitan.",
    "pending": "Mencari ayat berkaitan…"
  },
  "favorites": {
    "panel_aria": "Ayat kegemaran",
    "title": "Ayat Kegemaran",
    "proLocked": "Ayat kegemaran ialah ciri Pro.",
    "loading": "Memuatkan…",
    "failedToLoad": "Gagal memuatkan kegemaran",
    "empty": "Belum ada kegemaran. Ketik hati pada mana-mana ayat untuk menyimpannya.",
    "reference": "— Surah {{surah}}, Ayat {{ayah}}",
    "remove_aria": "Buang daripada kegemaran",
    "failedToRemove": "Gagal membuang"
  }
}
